//////////////////////////////

module.exports = (type) => {
    var schema = {
        first_name: {
            type: type.STRING(64),
            allowNull: false,
        },
        last_name: {
            type: type.STRING(64),
            allowNull: false,
        },
        codice_fiscale: {
            type: type.STRING(16),
            allowNull: false,
            validate: {
                is: /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i,
            },
        },
        email: {
            type: type.STRING(64),
            allowNull: false,
            validate: {
                isEmail: true,
            },
        },
        title: {
            type: type.STRING(64),
            allowNull: false,
        },
        note: {
            type: type.TEXT,
            allowNull: true,
        },
        created: {
            type: type.DATE,
            allowNull: false,
            defaultValue: type.NOW,
        },
        code: {
            type: type.STRING(128),
            allowNull: true,
        },
        created_by: {
            type: type.INTEGER,
            allowNull: false,
            references: {
                model       : 'users',
                key         : 'id',
                constraints : true,
                store_name  : 'user',
            }
        },
        file: {
            type: type.VIRTUAL,
            file: true,
            progress: true,
            allowNull: true,
            max_size: 2500000000,
            mime_types: [ 'application/pdf' ],
        },
        company_id: {
            type: type.INTEGER,
            allowNull: false,
            references: {
                model       : 'companies',
                key         : 'id',
                constraints : true,
                store_name  : 'company',
            }
        },
        config: {
            type: type.JSONB,
            allowNull: false,
            defaultValue: { status: 'set_qrcode_position' },
        },
        id: {
            type: type.INTEGER,
            primaryKey: true,
            autoIncrement: true
        },
    };

    return schema;
}


